import { render, staticRenderFns } from "./CreateCard.vue?vue&type=template&id=a226d536&scoped=true&"
import script from "./CreateCard.vue?vue&type=script&lang=ts&"
export * from "./CreateCard.vue?vue&type=script&lang=ts&"
import style0 from "./CreateCard.vue?vue&type=style&index=0&id=a226d536&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a226d536",
  null
  
)

export default component.exports